import { Location } from 'history';
import React from 'react';

// The location type from history doesn't include
// the hash or referer. Referer is needed in a few places,
// TODO - we should remove referer and get it from somewhere else.
export interface IUrl extends Location {
  hash?: string;
  referer?: string;
}

export interface WithUrlProps {
  url: IUrl;
}

export const URLContext = React.createContext<IUrl>({
  pathname: '',
  search: '',
  // A parsed-params object, matching what AppProvider supplies -- consumers
  // index into it, so a string default would silently read as "no params".
  query: {},
  state: '',
  action: 'PUSH',
  key: '',
});

// Minimal slices of IUrl for helpers that only read part of the URL.
// Structurally compatible with IUrl, react-router locations, and the legacy
// v3-style location objects still passed by some callers.
export interface UrlPathQuery {
  pathname?: string;
  query?: Record<string, any>;
}

export interface UrlPathSearch {
  pathname?: string;
  search?: string;
}

export function useURL(): IUrl {
  return React.useContext(URLContext);
}

export function withUrlContext<TProps>(Wrapped: React.ComponentType<TProps>): React.FunctionComponent<TProps> {
  const Component = (props: TProps) => (
    <URLContext.Consumer>
      {(urlContextObject) => (
        // eslint-disable-next-line react/jsx-props-no-spreading
        (<Wrapped url={urlContextObject} {...props} />)
      )}
    </URLContext.Consumer>
  );

  Component.displayName = `withUrlContext(${Wrapped.displayName || Wrapped.name})`;

  return Component;
}
